import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

export const ReportContentsSection = () => {
  const [showMore, setShowMore] = useState(false);

  const reportContents = [
    { number: "01", title: "Your Birth Chart", description: "Get a detailed view of your cosmic blueprint based on your date, time, and place of birth." },
    { number: "02", title: "Driver-Conductor Code", description: "Understand the unique number pairing that drives your energy and direction in life." },
    { number: "03", title: "Number Influence in Your DOB", description: "See how recurring and missing numbers shape your personality and destiny." },
    { number: "04", title: "Missing Number Remedies", description: "Receive simple, personalized remedies to restore balance and clarity." },
    { number: "05", title: "Energy Tools: Bracelet & Yantra", description: "Discover powerful tools recommended specifically to align your energy." },
    { number: "06", title: "Mobile Number Compatibility", description: "Analyze how your current mobile number affects your life path." },
    { number: "07", title: "Personality, Yogas & Health", description: "Reveal hidden strengths, potential challenges, and their impact on your well-being." },
    { number: "08", title: "Future & Career Forecast", description: "Gain insight into the next 5 years of your professional and personal journey." },
    { number: "09", title: "Personal Branding & Relationships", description: "Unlock lucky colors, business card design tips, and relationship dynamics based on your numbers." },
  ];

  const visibleContents = showMore ? reportContents : reportContents.slice(0, 3);

  return (
    <section className="bg-gradient-to-b from-cosmic-red/10 to-background-red">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16 pt-8">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground">
            This is what you get in the Report
          </h2>
        </div>

        {/* Report Contents Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {visibleContents.map((item, index) => (
            <Card key={index} className="p-6 border-cosmic-gold/20 bg-card-red/50 backdrop-blur-sm hover:shadow-[0_0_20px_hsl(var(--mystic-gold)/0.2)] transition-all duration-300">
              <div className="flex items-start space-x-4">
                {/* Number Badge */}
                <Badge className="bg-gradient-to-b from-cosmic-gold to-cosmic-gold-dark text-primary-foreground font-bold text-lg px-3 py-1 rounded-full flex-shrink-0">
                  {item.number}
                </Badge>
                
                {/* Content */}
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {item.description}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Show More Button */}
        {!showMore && (
          <div className="text-center">
            <Button 
              variant="cosmic-outline" 
              onClick={() => setShowMore(true)}
              className="group"
            >
              Show More
              <ChevronDown className="w-4 h-4 ml-2 group-hover:translate-y-1 transition-transform" />
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};